import styled, { keyframes } from 'styled-components';

import { parseHTML } from '@/lib/parse';

interface ItemProps {
	src: string;
	alt: string;
	desc: any;
}

const Item = ({ src, alt, desc }: ItemProps) => (
	<Interact>
		<InteractImg src={src} alt={alt} />

		<InteractDescription>{parseHTML(desc)}</InteractDescription>
	</Interact>
);

export const pulsing = keyframes`
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  to {
    transform: scale(1);
  }
`;

const Interact = styled.div`
	display: flex;
	margin-bottom: 30px;
	align-items: flex-start;

	@media (max-width: 980px) {
		margin-bottom: 20px;
	}
`;

const InteractImg = styled.img`
	margin-right: 40px;
	animation-name: ${pulsing};
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
	animation-fill-mode: both;
	animation-timing-function: linear;
	animation-play-state: running;

	@media (max-width: 600px) {
		margin-right: 15px;
	}
`;

const InteractDescription = styled.div`
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	transform: translateY(-7px);

	@media (max-width: 600px) {
		font-size: 16px;
	}
`;

export default Item;
